var React = require('react');

function Share (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-1209 -379)"},[React.createElement("rect",{"width":"22","height":"22","transform":"translate(1209 379)","fill":"none","key":0}),React.createElement("path",{"d":"M12.313,4.17,22.2,11.419l-9.889,8.574V15.377H10.506a5.25,5.25,0,0,0-3.459,1.3L3.25,20V15.373A6.75,6.75,0,0,1,10,8.623h2.313Zm1.5,2.959v2.993H10a5.25,5.25,0,0,0-5.25,5.25V16.7L6.059,15.55a6.75,6.75,0,0,1,4.448-1.672h3.306v2.83l5.986-5.19Z","transform":"translate(1207.75 377.829)","fill":"#b1b1b1","fillRule":"evenodd","key":1})]));
}

Share.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = Share;

Share.default = Share;
